// extracted by mini-css-extract-plugin
export default {"main":"Product_main__Ym7F1","div6":"Product_div6__m43iZ","cons":"Product_cons__eDF79"};